import {apiUrl} from '../constant';
import {authtoken} from 'global.js';
const axios = require("axios");
export const reportmanageService = {
    getReportData,
    getReportDetails,
    download_report,
    getDailyReportData,
    getWeeklyReportData,
    getMonthlyReportData,
    getDailyReportDetails,
    getWeeklyReportDetails,
    getMothlyReportDetails,
    daily_report_export,
    weekly_report_export,
    monthly_report_export,
    billing_report_export,
    getReportRejections,
    download_rejection_report,
    download_external_rejection_report,
    download_without_checklisterror_report,
    download_without_error_report,
    getReportSummary,
    rejection_summary_export,
    getwithoutErrorReport,
    getReportRejectionsExternal,
    getGovernnaceSummary,
    download_governance_data,
    download_clienttransition_data,
    download_governance_summary,
    download_internal_governance_data,
    getBillingReportData,
    download_internal_data,
    getmanagerRejectionData,
    getPhasesMISReportData,
    getPhasesMISReportDataDownload,
    governanceReport,
    getGovernnaceReport,
    getturnoverReport,
    getwithoutChecklistErrorReport,
    getExpireTaskList,
    getClientHoursReport,
    getJobAllocationReportDataDownload,
    getUserwiseReport,
    taskdetails,
    getUserwiseReportExport,
    getCcrpMisReport,
    downloadCcrpMisReport,
    getCCRPMisData,
    getInternalPhaseErrorReport,
    exportInternalPhaseErrorReport,
    updateInternalPhaseErrorStatus,
    getPhaseTatReport,
    getPhaseTatHoldDetails,
    exportPhaseTatReport,
    getDocumentTypeEditReport,
    exportDocumentTypeEditReport,
    getDocumentTypeEditReportDetails,
    getTurnaroundReport,
    getTurnaroundJobs,
    getTurnaroundDueDateChanges
};

function getTurnaroundReport(manager_id = '', client = '') {
  return axios({
    method: "get",
    url: `${apiUrl}/turnaround-report?manager_id=${manager_id}&client=${encodeURIComponent(client)}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
      if (response.status == 200) {
        return response;
      }
    }, error => {
      return error.response;
    })
    .catch(function (error) {});
}

function getTurnaroundJobs(kpi, manager_id, client, page = 1, per_page = 25) {
  return axios({
    method: "get",
    url: `${apiUrl}/turnaround-report/jobs?kpi=${kpi}&manager_id=${manager_id}&client=${encodeURIComponent(client)}&page=${page}&per_page=${per_page}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
      if (response.status == 200) {
        return response;
      }
    }, error => {
      return error.response;
    })
    .catch(function (error) {});
}

function getTurnaroundDueDateChanges(manager_id, client, page = 1, per_page = 25) {
  return axios({
    method: "get",
    url: `${apiUrl}/turnaround-report/due-date-changes?manager_id=${manager_id}&client=${encodeURIComponent(client)}&page=${page}&per_page=${per_page}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
      if (response.status == 200) {
        return response;
      }
    }, error => {
      return error.response;
    })
    .catch(function (error) {});
}
function getWeeklyReportData(phase){
  return axios({
      method: "get",
      url: `${apiUrl}/user-weekly-report?phase_id=${phase}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
} 
function getReportData(start_date,end_date,sortfield,sortorder){
  if(start_date!=null && end_date!=null){
    var sendData = '?start_date='+start_date+'&end_date='+end_date+'&sort='+sortfield+'&order='+sortorder;
  }else{
    var sendData = '?sort='+sortfield+'&order='+sortorder;
  }
    return axios({
        method: "get",
        url: `${apiUrl}/report-data${sendData}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
        .then(function (response) {
           if(response.status == 200){
                return response;  
           }
        }, error => {
          return error.response;
          console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });      
}
function getReportDetails(userid,type,status,page,start_date,end_date){
  if(start_date!=null && end_date!=null){
    var sendData = '&start_date='+start_date+'&end_date='+end_date;
  }else{
    var sendData = '';
  }
  let client =encodeURIComponent(userid);
    return axios({
        method: "get",
        url: `${apiUrl}/report-details?id=${client}&type=${type}&status=${status}&page=${page}${sendData}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
        .then(function (response) {
           if(response.status == 200){
                return response;  
           }
        }, error => {
          return error.response;
          console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });      
}
function download_report(userid,type,status,start_date,end_date){
  if(start_date!=null && end_date!=null){
    var sendData = '&start_date='+start_date+'&end_date='+end_date;
  }else{
    var sendData = '';
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/report-details-export?id=${userid}&type=${type}&status=${status}${sendData}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `workflow-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function getDailyReportData(phase){
   //user-daily-report
   return axios({
    method: "get",
    // responseType: 'blob', 
    url: `${apiUrl}/user-daily-report?phase_id=${phase}`,
    headers: { Authorization: `Bearer ${authtoken}`},
  })
  .then(function (response) {
      // console.log('daily report');
      // console.log(response);
      return response;
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });

}
function getMonthlyReportData(phase,start_date,end_date){
  if(start_date!=null && end_date!=null){
    var sendData = '&start_date='+start_date+'&end_date='+end_date;
  }else{
    var sendData = '';
  }
  return axios({
      method: "get",
      url: `${apiUrl}/user-monthly-report?phase_id=${phase}${sendData}`,
      headers: {Authorization: `Bearer ${authtoken}` }
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function getDailyReportDetails(userid,role_id,status,page,search,filter,filtertype,sortfield,sortorder){
  return axios({
      method: "get",
      url: `${apiUrl}/daily-report-details?user_id=${userid}&role_id=${role_id}&status=${status}&page=${page}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function getWeeklyReportDetails(company,phase,page,search,filter,filtertype,sortfield,sortorder){
  let client =encodeURIComponent(company);
  return axios({
      method: "get",
      url: `${apiUrl}/weekly-report-details?company=${client}&phase_id=${phase}&page=${page}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function getMothlyReportDetails(company,status,role_id,page,search,filter,filtertype,sortfield,sortorder){
  //console.log(company);
  let client =encodeURIComponent(company);
  let current_url= `${apiUrl}/monthly-report-details?status=${status}&company=${client}&page=${page}`;
  if(status==''){
    current_url = `${apiUrl}/monthly-report-details?company=${client}&page=${page}`;
  }else if(role_id==4 && status !=''){
    current_url = `${apiUrl}/monthly-report-details?status=${status}&user_id=${client}&page=${page}`;
  }else if(role_id==4 && status ==''){
    current_url = `${apiUrl}/monthly-report-details?user_id=${client}&page=${page}`; 
  }

  return axios({
      method: "get",
      url:current_url ,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function daily_report_export(userid,type,status){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/daily-report-export`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `daily-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function weekly_report_export(userid,type,status){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/weekly-report-export`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `daily-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function monthly_report_export(start_date,end_date){
  if(start_date!=null && end_date!=null){
    var sendData = '?start_date='+start_date+'&end_date='+end_date;
  }else{
    var sendData = '';
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/monthly-report-export${sendData}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `monthly-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function getReportRejections(page,start_date,end_date,per_page,client){
   if(start_date!=null && end_date!=null){
    var sendData = `&start_date=${start_date}&end_date=${end_date}&per_page=${per_page}&client=${encodeURIComponent(client)}`;

   }else{
    var sendData = '';
   }
    return axios({
        method: "get",
        url: `${apiUrl}/rejection-report?page=${page}${sendData}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
        .then(function (response) {
           if(response.status == 200){
                return response;  
           }
        }, error => {
          return error.response;
          console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });      
}

function getReportRejectionsExternal(page,search,filter,filtertype,per_page,start_date,end_date){
  let filters = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
  if(start_date!=null && end_date!=null){
    var sendData = '&start_date='+start_date+'&end_date='+end_date+'&per_page='+per_page;
  }else{
   var sendData = '';
  }
  return axios({
    method: "get",
    url: `${apiUrl}/external-rejection-report?page=${page}&search=${search}${filters}${typefilter}&per_page=${per_page}${sendData}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });    
}

function download_rejection_report(start_date,end_date,client){
  var sendData = '';  // Initialize sendData

  // Check if start_date and end_date are provided, and append them if they are
  if (start_date != null && end_date != null) {
      sendData += `&start_date=${start_date}&end_date=${end_date}`;
  }
  
  // Check if client is provided, and append it to sendData
  if (client) {
      sendData += `&client=${encodeURIComponent(client)}`;
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/report-rejection-export?${sendData}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `rejection-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function download_external_rejection_report(filter,filtertype,start_date,end_date){
  let filters = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/external-rejection-export?search=''${filters}${typefilter}&start_date=${start_date}&end_date=${end_date}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `external-ccrp-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function download_without_error_report(){
 
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/report-without-rejection-export`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `workflow-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function download_without_checklisterror_report(start_date,end_date,filter){
  var sendData = '';  // Initialize sendData
  var filters='';
  // Check if start_date and end_date are provided, and append them if they are
  if (start_date != null && end_date != null) {
      sendData += `&start_date=${start_date}&end_date=${end_date}`;
  }

  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/report-without-checklisterror-export?${sendData}${filters}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `workflow-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function getReportSummary(){
  return axios({
    method: "get",
    url: `${apiUrl}/rejection-summary`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });   
}

function rejection_summary_export(){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/rejection-summary-export`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `rejection-summary-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}


function download_governance_data(filter,filtertype){
  let filters = '';
  let search = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/governance-data-export?search=${search}${filters}${typefilter}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `governance-data-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function download_clienttransition_data(){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/clienttransition-data-export`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `client-transition-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}

function getwithoutErrorReport(page){
  
  return axios({
      method: "get",
      url: `${apiUrl}/report-without-rejection?page=${page}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}

function getwithoutChecklistErrorReport(page,start_date,end_date,per_page,filter){
  if(start_date!=null && end_date!=null){
    var sendData = `&start_date=${start_date}&end_date=${end_date}&per_page=${per_page}`;
 
   }else{
    var sendData = '';
   }
   let filters = '';
  let search = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  return axios({
      method: "get",
      url: `${apiUrl}/report-without-checklist-rejection?page=${page}${sendData}${filters}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function getGovernnaceSummary(){
  return axios({
    method: "get",
    url: `${apiUrl}/governance-summary`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });     
}

function download_governance_summary(){
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/governance-summary-export`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `governance-summary-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    }); 
}
function download_internal_governance_data(filter,filtertype){
  let filters = '';
  let search = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/internal-governance-data-export?search=${search}${filters}${typefilter}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `internal-governance-data-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function getBillingReportData(start_date,end_date,sortfield,sortorder){
  if(start_date!=null && end_date!=null){
    var sendData = '?start_date='+start_date+'&end_date='+end_date+'&sort='+sortfield+'&order='+sortorder;
  }else{
    var sendData = '?sort='+sortfield+'&order='+sortorder;
  }
    return axios({
        method: "get",
        url: `${apiUrl}/billing-report-data${sendData}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
        .then(function (response) {
           if(response.status == 200){
                return response;  
           }
        }, error => {
          return error.response;
          console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        });      
}

function billing_report_export(start_date,end_date=null){
  if(start_date!=null){
    var sendData = '?start_date='+start_date+'&end_date='+end_date;
  }else{
    var sendData = '';
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/billing-report-export${sendData}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `billing-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}
function download_internal_data(filter,filtertype){
  let filters = '';
  let search = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
  return axios({
    method: "get",
    responseType: 'blob', 
    url: `${apiUrl}/internal-data-export?search=${search}${filters}${typefilter}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `internal-data-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
// return response;
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });  
}

function getmanagerRejectionData(table,page,search,filter,filtertype,per_page){
  let filters = '';
  if(filter){
     filters = `&filters=${JSON.stringify(filter)}`;
  }
  let typefilter = '';
  if(filtertype!=''){
     typefilter = `&filtertype=${filtertype}`;
  }
    return axios({
        method: "get",
        url: `${apiUrl}/getmanagerRejectionData?table=${table}&page=${page}&search=${search}${filters}${typefilter}&per_page=${per_page}`,
        headers: {Authorization: `Bearer ${authtoken}` },
      })
        .then(function (response) {
           if(response.status == 200){
                return response;  
           }
        }, error => {
          return error.response;
          console.log(error.response.status);
        })
        .catch(function (error) {
          // console.log(error.response.status);
        }); 
}

function getPhasesMISReportData(phase,start_date,end_date,download){
  if(start_date!=null && end_date!=null){
    var sendData = '?start_date='+start_date+'&end_date='+end_date;
  }else{
    var sendData = '';
  }
  return axios({
      method: "get",
      url: `${apiUrl}/getMISdataphases${sendData}`,
      headers: {Authorization: `Bearer ${authtoken}` }
    })
      .then(function (response) {
         if(response.status == 200){
              return response;  
         }
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function getPhasesMISReportDataDownload(start_date,end_date,download){
  if(start_date!=null && end_date!=null){
    var sendData = '?start_date='+start_date+'&end_date='+end_date+'&download=1';
  }else{
    var sendData = '?download=1';
  }
  return axios({
      method: "get",
      responseType: 'blob', 
      url: `${apiUrl}/getMISdataphases${sendData}`,
      headers: {Authorization: `Bearer ${authtoken}` }
    })
      .then(function (response) {
        const outputFilename = `MIS-Phase-report-${Date.now()}.xlsx`;
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', outputFilename);
        document.body.appendChild(link);
        link.click();
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function governanceReport(filters){
  const { month, type } = filters;
   
    return axios({
      method: "get",
      responseType: 'blob', 
      url: `${apiUrl}/governance-report-export?month=${month}&type=${type}`,
      headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
    })
    .then(function (response) {
      const outputFilename = `governance-data-report-${Date.now()}.xlsx`;
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
  // return response;
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });  
}

function getGovernnaceReport(page, rowsPerPage, filters) {
  const { fromDate, toDate, type } = filters;
  return axios({
    method: "get",
    url: `${apiUrl}/getGovernnaceReport?page=${page}&rowsPerPage=${rowsPerPage}&fromDate=${fromDate}&toDate=${toDate}&type=${type}`,
    headers: { Authorization: `Bearer ${authtoken}` }
  })
  .then(function (response) {
    if(response.status === 200){
      return response;  
    }
  }, error => {
    console.log(error.response.status);
    return error.response;
  })
  .catch(function (error) {
    console.error(error);
  });      
}
function getturnoverReport(page,filters,filtertype, rowsPerPage,client,start_date,end_date ){
  return axios({
    method: "get",
    url: `${apiUrl}/getturnoverReport?page=${page}&per_page=${rowsPerPage}&client=${encodeURIComponent(client)}&start_date=${start_date}&end_date=${end_date}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });     
}
function getExpireTaskList(page,filters,filtertype, rowsPerPage,is_list ){
  return axios({
    method: "get",
    url: `${apiUrl}/getExpireTaskList?page=${page}&per_page=${rowsPerPage}&is_list=${is_list}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;  
       }
    }, error => {
      return error.response;
      console.log(error.response.status);
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });     
}

function getClientHoursReport(params) {
  const { start_date, end_date, client = "" } = params;

  return axios({
    method: "get",
    url: `${apiUrl}/client-hours-report?start_date=${start_date}&end_date=${end_date}&client=${encodeURIComponent(client)}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then((response) => {
      if (response.status === 200) {
        return response;
      }
    })
    .catch((error) => {
      console.error(error.response?.status || error);
      return error.response;
    });
}
function getJobAllocationReportDataDownload(start_date,end_date,client){
  
  return axios({
      method: "get",
      responseType: 'blob', 
      url: `${apiUrl}/client-hours-report?start_date=${start_date}&end_date=${end_date}&download=1&client=${encodeURIComponent(client)}`,
      headers: {Authorization: `Bearer ${authtoken}` }
    })
      .then(function (response) {
        const outputFilename = `Job-Allocation-report-${Date.now()}.xlsx`;
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', outputFilename);
        document.body.appendChild(link);
        link.click();
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function getUserwiseReport(params,sortfield,sortorder) {
  console.log(params);
  const { client = "", team_member = "",status="",date_change="",type="" } = params;

  return axios({
    method: "get",
    url: `${apiUrl}/getQaJobsReport?client=${encodeURIComponent(client)}&team_member=${encodeURIComponent(team_member)}&status=${encodeURIComponent(status)}&date_change=${encodeURIComponent(date_change)}&sort=${sortfield}&order=${sortorder}&type=${encodeURIComponent(type)}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then((response) => {
      if (response.status === 200) {
        return response;
      }
    })
    .catch((error) => {
      console.error(error.response?.status || error);
      return error.response;
    });
}
function getUserwiseReportExport(client,team_member,status,date_change,type){
  
  return axios({
      method: "get",
      responseType: 'blob', 
      url: `${apiUrl}/getQaJobsReport?download=1&client=${encodeURIComponent(client)}&team_member=${encodeURIComponent(team_member)}&status=${encodeURIComponent(status)}&date_change=${encodeURIComponent(date_change)}&type=${encodeURIComponent(type)}`,
      headers: {Authorization: `Bearer ${authtoken}` }
    })
      .then(function (response) {
        const outputFilename = `Job-Allocation-report-${Date.now()}.xlsx`;
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', outputFilename);
        document.body.appendChild(link);
        link.click();
      }, error => {
        return error.response;
        console.log(error.response.status);
      })
      .catch(function (error) {
        // console.log(error.response.status);
      });      
}
function taskdetails(status,ageing,data){
 
  return axios({
      method: "get",
      url: `${apiUrl}/taskdetails?user_id=${data.user_id}&tl_id=${data.tl_id}&status=${status}&ageing=${ageing}&type=${data.type}&date_type=${data.date_type}`,
      headers: {Authorization: `Bearer ${authtoken}` },
    })
    .then(function (response) {
      if(response.status == 200){
        return response;
       }
      }, error => {
        return error.response;
      })
      .catch(function (error) {
        console.log(error.response.status);
      });      

}

function getCcrpMisReport(params) {
  const { start_date, end_date, client = "", manager_id = "" } = params;

  const queryParams = new URLSearchParams({
    start_date,
    end_date,
    client,
    manager_id,
  });

  return axios({
    method: "get",
    url: `${apiUrl}/ccrp-mis-report?${queryParams.toString()}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then((response) => {
      if (response.status === 200 && response.data) {
        return response.data; // Return only actual data payload
      }
      throw new Error("Unexpected response format");
    })
    .catch((error) => {
      console.error("Error fetching CCRP MIS Report:", error.response?.data || error.message);
      throw error.response?.data || error;
    });
}

function downloadCcrpMisReport(start_date,end_date,manager_id){
  return axios({
    method: "get",
    responseType: 'blob',
    url: `${apiUrl}/ccrp-mis-report-export?start_date=${start_date}&end_date=${end_date}&manager_id=${manager_id}`,
    headers: { Authorization: `Bearer ${authtoken}`, "Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `ccrp-mis-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      console.log(error.response.status);
    });
}
function getCCRPMisData(params) {
  const { start_date, end_date, client = "", manager_id = "",type,client_name="",date_of_complaint="" } = params;

  const queryParams = new URLSearchParams({
    start_date,
    end_date,
    client,
    manager_id,
    type,
    client_name,
    date_of_complaint
  });

  return axios({
    method: "get",
    url: `${apiUrl}/getCCRPMisData?${queryParams.toString()}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then((response) => {
      if (response.status === 200 && response.data) {
        return response.data; // Return only actual data payload
      }
      throw new Error("Unexpected response format");
    })
    .catch((error) => {
      console.error("Error fetching CCRP MIS Report:", error.response?.data || error.message);
      throw error.response?.data || error;
    });
}
function getInternalPhaseErrorReport(start_date='', end_date='', page=1, per_page=25){
  return axios({
    method: "get",
    url: `${apiUrl}/internal-phase-error-report?start_date=${start_date}&end_date=${end_date}&page=${page}&per_page=${per_page}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function exportInternalPhaseErrorReport(start_date='', end_date=''){
  return axios({
    method: "get",
    responseType: 'blob',
    url: `${apiUrl}/internal-phase-error-export?start_date=${start_date}&end_date=${end_date}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `internal-phase-error-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function phaseTatQuery(filters){
  const p = new URLSearchParams();
  Object.keys(filters || {}).forEach((k) => {
    if(filters[k] !== '' && filters[k] !== null && filters[k] !== undefined){
      p.append(k, filters[k]);
    }
  });
  return p.toString();
}
function getPhaseTatReport(filters, page=1, per_page=25){
  const query = phaseTatQuery({...filters, page, per_page});
  return axios({
    method: "get",
    url: `${apiUrl}/phase-tat-report?${query}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function getPhaseTatHoldDetails(task_id, team){
  return axios({
    method: "get",
    url: `${apiUrl}/phase-tat-report/hold-details?task_id=${task_id}&team=${encodeURIComponent(team)}`,
    headers: {Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function exportPhaseTatReport(filters){
  const query = phaseTatQuery(filters);
  return axios({
    method: "get",
    responseType: 'blob',
    url: `${apiUrl}/phase-tat-export?${query}`,
    headers: { Authorization: `Bearer ${authtoken}`,"Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `phase-tat-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    }, error => {
      return error.response;
    })
    .catch(function (error) {
      // console.log(error.response.status);
    });
}
function updateInternalPhaseErrorStatus(id, status){
  return axios({
    method: "post",
    url: `${apiUrl}/internal-phase-error-status`,
    data: { id: id, status: status },
    headers: { Authorization: `Bearer ${authtoken}` },
  })
  .then(function (response) {
    if(response.status == 200){
      return response;
    }
  }, error => {
    return error.response;
  })
  .catch(function (error) {
    // console.log(error.response.status);
  });
}
function getDocumentTypeEditReport(from='', to=''){
  return axios({
    method: "get",
    url: `${apiUrl}/document-type-edit-report?from=${from}&to=${to}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
    });
}

function exportDocumentTypeEditReport(from='', to=''){
  return axios({
    method: "get",
    responseType: 'blob',
    url: `${apiUrl}/document-type-edit-report-export?from=${from}&to=${to}`,
    headers: { Authorization: `Bearer ${authtoken}`, "Content-Type": "application/vnd.ms-excel" },
  })
  .then(function (response) {
    const outputFilename = `document-type-edit-report-${Date.now()}.xlsx`;
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    }, error => {
      return error.response;
    })
    .catch(function (error) {
    });
}

function getDocumentTypeEditReportDetails(from='', to='', changedOnly=0, page=1, per_page=25){
  return axios({
    method: "get",
    url: `${apiUrl}/document-type-edit-report-details?from=${from}&to=${to}&changed_only=${changedOnly}&page=${page}&per_page=${per_page}`,
    headers: { Authorization: `Bearer ${authtoken}` },
  })
    .then(function (response) {
       if(response.status == 200){
            return response;
       }
    }, error => {
      return error.response;
    })
    .catch(function (error) {
    });
}
